<template>
    <rkm-area title="Encerrar gestação">
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="data.form.preNatal.gravidezTipos"
                    label="Tipo de gravidez"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.preNatal.gravidezTipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-date-picker
                    :min-date="data.additionals.paciente.dataNascimento"
                    :validations="validations.desfechoEm"
                    label="Data do desfecho"
                    v-model="data.model.preNatal.desfechoEm"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                desfechoEm: {required: true},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>